export const ContactTypes: {
  value: 'phone' | 'sms' | 'both';
  display: string;
}[] = [
  { value: 'phone', display: 'Voice Call' },
  { value: 'sms', display: 'Text Message' },
  { value: 'both', display: 'Both' },
];

export const SpamCategories = [
  { value: 'scam', display: 'Suspected Scam / Suspicious' },
  { value: 'warranty', display: 'Auto Warranty' },
  {
    value: 'charity',
    display: 'Charities / Non-Profit Fundraising',
  },
  { value: 'debt', display: 'Debt Collector' },
  {
    value: 'political',
    display: 'Political / Political Fundraising',
  },
  { value: 'sales', display: 'Sales Call' },
  {
    value: 'service',
    display: 'Service Providers (Deliveries, Utilities, Maintenance, etc.)',
  },
  { value: 'survey', display: 'Survey / Research' },
  { value: 'unsure', display: 'Unsure' },
  { value: 'other', display: 'Other' },
];

export const ScamTypes: { value: string; display: string }[] = [
  { value: 'bank', display: 'Bank / Credit Card' },
  { value: 'charity', display: 'Charities / Donations' },
  { value: 'debt', display: 'Debt Collection' },
  {
    value: 'energy',
    display: 'Energy / Utilities / Solar Panels',
  },
  { value: 'family', display: 'Family or Friend Impersonation' },
  { value: 'food', display: 'Food Delivery' },
  { value: 'gift', display: 'Gift Cards' },
  { value: 'home', display: 'Home Security / Alarms' },
  { value: 'investments', display: 'Investments / Crypto' },
  { value: 'irs', display: 'IRS / Taxes' },
  { value: 'jobs', display: 'Jobs / Work from Home' },
  {
    value: 'law',
    display: 'Law Enforcement / FBI / Legal Action',
  },
  {
    value: 'logins',
    display: 'Logins / Tech Support / Computer-Related',
  },
  {
    value: 'medical',
    display: 'Medical / Healthcare / Prescriptions',
  },
  { value: 'medicare', display: 'Medicare / Medicaid' },
  { value: 'package', display: 'Package Delivery' },
  { value: 'prizes', display: "Prizes / You've Won Something" },
  { value: 'social', display: 'Social Security' },
  { value: 'student', display: 'Student Loans' },
  { value: 'travel', display: 'Travel / Vacation' },
  { value: 'other', display: 'Other' },
];
